import type { TrigKey } from './keys';

export const bn: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'গণিত · ত্রিকোণমিতি',
  'panel.experiment': 'পরীক্ষা',
  'panel.params': 'প্যারামিটার',
  'panel.scene': 'একটি পরীক্ষা বাছুন',
  'experiment.right-triangle.label': 'সমকোণী ত্রিভুজ',
  'experiment.unit-circle.label': 'একক বৃত্ত',
  'experiment.wave-studio.label': 'তরঙ্গ স্টুডিও',
  'experiment.identity-playground.label': 'অভেদ',
  'experiment.triangle-solver.label': 'ত্রিভুজ সমাধানকারী',
  'experiment.circular-polar.label': 'বৃত্তীয় ও মেরু',
  'hint.line1': 'বিন্দু টানুন, স্লাইডার নাড়ান।',
  'hint.line2': 'শিক্ষামূলক বিষয় জ্যামিতিতে, পাঠ্যে নয়।',
  'rt.angle.a': 'কোণ A',
  'rt.angle.b': 'কোণ B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'রেডিয়ান',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° এ স্ন্যাপ',
  'uc.units': 'একক',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC দেখান',
  'uc.snap.common': 'সাধারণ কোণে স্ন্যাপ',
  'uc.angle.value': '∠',
  'uc.units.deg': 'ডিগ্রি',
  'uc.units.rad': 'রেড',
  'uc.units.both': 'ডিগ্রি+রেড',
  'ws.fn': 'ফাংশন',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — বিস্তার',
  'ws.frequency': 'B — কম্পাঙ্ক',
  'ws.phase': 'C — দশাস্থানান্তর',
  'ws.shift': 'D — উল্লম্ব সরণ',
  'ws.rform.toggle': 'R-রূপ উদ্ভব',
  'ws.rform.a': 'a (sin সহগ)',
  'ws.rform.b': 'b (cos সহগ)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'রিসেট',
  'ws.base': 'মূল বক্ররেখা দেখান',
  'ip.id.pythagorean': 'পিথাগোরীয়',
  'ip.id.reciprocal': 'বিপরীত',
  'ip.id.quotient': 'ভাগফল',
  'ip.id.sum': 'যোগ',
  'ip.id.difference': 'বিয়োগ',
  'ip.id.double': 'দ্বিগুণ কোণ',
  'ip.id.half': 'অর্ধ-কোণ',
  'ip.play': 'চালু',
  'ip.pause': 'থামান',
  'ip.step': 'ধাপ',
  'ip.reset': 'রিসেট',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2-তে আসছে — এই প্রমাণে আরও বিস্তৃত গঠন দরকার।',
  'ts.area': 'ক্ষেত্রফল',
  'ts.sineRule': 'sine সূত্র',
  'ts.cosineRule': 'cosine সূত্র',
  'ts.ambiguous.toggle': 'দ্ব্যর্থ হলে ভূত-ত্রিভুজ',
  'ts.reset': 'সমবাহুতে রিসেট',
  'ts.snap.integers': 'পূর্ণসংখ্যায় স্ন্যাপ',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'বাহু',
  'ts.section.angles': 'কোণ',
  'ts.section.sineRule': 'sine সূত্র',
  'ts.section.cosineRule': 'cosine সূত্র',
  'ts.section.area': 'ক্ষেত্রফল',
  'cp.omega': 'কোণীয় বেগ',
  'cp.plot.y': 'y প্লট (sin)',
  'cp.plot.x': 'x প্লট (cos)',
  'cp.polar.label': 'মেরু চিত্র',
  'cp.polar.circle': 'বৃত্ত (r = 1)',
  'cp.polar.rose': 'গোলাপ (r = sin 3θ)',
  'cp.polar.cardioid': 'হৃদয়াকার (r = 1 + cos θ)',
  'cp.polar.limacon': 'লিমাসন (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'ছোট কোণ আসন্নকরণ (sin x ≈ x)',
  'cp.play': 'চালু',
  'cp.pause': 'থামান',
  'cp.reset': 'রিসেট',
  'cp.step': 'ধাপ π/12',
};
